import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { NEVER, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { BinderWizardService } from '../services/sections/binder/binder-wizard.service';
import { BinderSetupData } from '../models/binder/binder-setup-data.model';

@Injectable({
	providedIn: 'root'
})
export class BinderSetupDataResolver implements Resolve<Observable<BinderSetupData>> {

	constructor(
		private router: Router,
		private binderWizardService: BinderWizardService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;
		GlobalSettingsService.navigationBarActions.clear();
		GlobalSettingsService.isJobCompletedStatusVisible = false;

		return this.binderWizardService
			.getBinderYears(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				})
			);
	}
}
